exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:992px){html:not(.lt-ie10) .winres-web-component .h2,html:not(.lt-ie10) .winres-web-component h2{text-align:left}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap&includePaths[]=/home/jenkins/work/workspace/Lumo_deploy_feature-test-3/~/breakpoint-sass/stylesheets!./src/webComponents/styles/custom/kymi.nopostcss.sass
// module id = 718
// module chunks = 2